/**
 * The Value for the User Roles
 */
export enum USER_ROLE {
    SERVICE_AGENT = 'service_agent',
    DEMO = 'demo'
}
